module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/table-scroll-desktop/table-scroll-desktop.component.scss
// module id = ./src/app/features/typography/table-scroll-desktop/table-scroll-desktop.component.scss
// module chunks = main